import {
    List,
    ListItem,
    ListItemPrefix,
} from "@material-tailwind/react";
import {
    PowerIcon,
} from "@heroicons/react/24/solid";
import Link from "next/link";
import { useDispatch } from "react-redux";
import { useContext } from "react";
import { useRouter, usePathname } from "next/navigation";
import myContext from "@/context/myContext";
import { useLogoutMutation } from "@/redux/slices/authSlice";
import apiSlice from "@/redux/slices/apiSlice";
import { LogOut } from "lucide-react";

export default function TopnavBar() {
    const dispatch = useDispatch();
    const router = useRouter();
    const { updateAuthState } = useContext(myContext);
    const [logout] = useLogoutMutation();
    const pathname = usePathname();

    const handleLogout = async () => {
        await logout();
        updateAuthState();
        dispatch(apiSlice.util.resetApiState());
        router.push("/");
    };

    const isActive = (path) => pathname === path;

    return (
        <div className="sm:hidden w-full bg-white border-b border-gray-300 p-2 shadow-md">
             <div className="flex justify-between items-center mb-6 p-2 border-b border-gray-200">
                <h3 className="text-sm font-semibold text-black">Manage your Account</h3>
                <button
                    onClick={handleLogout}
                    className="flex items-center gap-1 px-3 py-2 rounded-md hover:bg-gray-100 text-red-600"
                >
                    <LogOut className="h-5 w-5" />
                    Log Out
                </button>
            </div>
            <div className="flex flex-col flex-wrap justify-start items-start gap-2 text-sm font-medium text-gray-800 w-full">
    <Link href="/user/home" className="w-full">
        <div
            className={`w-full px-3 py-2 rounded-md ${
                isActive("/user/home") ? "bg-gray-200 text-gray-900 font-semibold" : ""
            }`}
        >
            Basic Profile
        </div>
    </Link>

    <Link href="/user/rent-property" className="w-full">
        <div
            className={`w-full px-3 py-2 rounded-md ${
                isActive("/user/rent-property") ? "bg-gray-200 text-gray-900 font-semibold" : ""
            }`}
        >
            Your Properties
        </div>
    </Link>

    <Link href="/user/enquiries" className="w-full">
        <div
            className={`w-full px-3 py-2 rounded-md ${
                isActive("/user/enquiries") ? "bg-gray-200 text-gray-900 font-semibold" : ""
            }`}
        >
            Interested in your Properties
        </div>
    </Link>
</div>

        </div>
    );
}
